import React, { useEffect, useState } from 'react';
import Hero from './Hero';
import ProjectCards from './ProjectCards';
import Skills from './Skills';
import Contact from './Contact';
import Experience from './Experience';
import Education from './Education';
import '../styles/body.css';

const Body = () => {
    const projects = [
        {
            id: 1,
            name: "VidChap / Capstone Project",
            description: "A video chaptering tool leveraging AI.",
            tags: ["BERT", "BART", "Airflow", "GCP", "Render"],
            url: "https://gitlab.com/capstone-project10/vidchap"
        },
        {
            id: 2,
            name: "Medical Image Diagnosis with CNN",
            description: "A neural network for diagnosing medical images using Convolutional Neural Networks (CNN).",
            tags: ["CNN", "Medical Imaging", "Deep Learning"],
            url: "https://gitlab.com/neutal-netwok/medical-image-diagnosis-with-cnn"
        },
        {
            id: 3,
            name: "Severity Prediction US Roads",
            description: "A predictive model for road accident severity, deployed on AWS with a Streamlit frontend.",
            tags: ["Streamlit", "AWS", "Machine Learning"],
            url: "https://gitlab.com/ai-group-lambton/severity-prediction-us-roads"
        },
        {
            id: 4,
            name: "Portfolio Project",
            description: "Personal portfolio showcasing skills, projects, and achievements.",
            tags: ["React", "Portfolio", "Frontend"],
            url: "https://gitlab.com/bipinnepal43/portfolio-project"
        },
        {
            id: 5,
            name: "Breast Cancer Prediction",
            description: "Developed a machine learning model for early-stage breast cancer prediction.",
            tags: ["Machine Learning", "Medical Data", "Prediction"],
            url: "https://gitlab.com/bipinnepal43/breast-cancer-prediction"
        },
        {
            id: 6,
            name: "Bitcoin Price Prediction",
            description: "A time-series analysis project predicting future Bitcoin prices.",
            tags: ["Time Series", "Cryptocurrency", "Data Analysis"],
            url: "https://gitlab.com/bipinnepal43/bitcoin-price-prediction"
        },
        {
            id: 7,
            name: "Flight Status Prediction",
            description: "Predicting flight delays using machine learning models and real-time data.",
            tags: ["ML", "Flight Data", "Prediction"],
            url: "https://gitlab.com/bipinnepal43/flight-status-prediction"
        },
        {
            id: 9,
            name: "Campus Placement Prediction",
            description: "A machine learning project predicting campus placement chances for students.",
            tags: ["Machine Learning", "Education", "Prediction"],
            url: "https://gitlab.com/bipinnepal43/campus-placement-prediction"
        }
    ];
    return (
        <section className="body">
            <div className="container" id="home">
                <Hero />
                <div id="projects">
                    <h2>Projects</h2>
                    <ProjectCards projects={projects} />
                </div>
                <div id="skills">
                    <h2>Skills</h2>
                    <Skills />
                </div>
                <div id="experience">
                    <h2>Professional Journey</h2>
                    <Experience />
                </div>
                <div id="education">
                    <h2>Education</h2>
                    <Education />
                </div>
                <div id="contact">
                    <h2>Stay In Touch With Me</h2>
                    <Contact />
                </div>
            </div>
        </section>
    );
}

export default Body;